<div class="confirm-close-position">
	<div class="wrapper">
		<app-image
			class="image"
			imageSrc="/images/icons/alert.svg"
			imageAlt="alert"
		/>

		<div class="inner">
			<h3 class="title">{{ 'confirmClosePosition.title' | translate }}</h3>
			<p class="description">{{ 'confirmClosePosition.description_1' | translate }}</p>
			<p class="description">{{ 'confirmClosePosition.description_2' | translate }}</p>
			<p class="description">{{ 'confirmClosePosition.description_3' | translate }}</p>

			<div class="btns">
				<app-button
					appearance="outline"
					size="m"
					(clicked)="close()"
				>
					{{ 'confirmClosePosition.cancelButton' | translate }}
				</app-button>

				<app-button
					appearance="primary"
					size="m"
					(clicked)="confirm()"
					[isLoading]="isLoading"
				>
					{{ 'confirmClosePosition.confirmButton' | translate }}
				</app-button>
			</div>
		</div>
	</div>
</div>
